import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { OAuthModule } from 'angular-oauth2-oidc';

import { BaseSpinnerComponent } from '@d-components/spinner/spinner.component';
import { BaseToastComponent } from '@d-components/toast/toast.component';

import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './layout/layout.module';

//i18n
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

//redux
import { AuthEffects, authReducer } from '@d-store/auth';
import { UserEffects } from '@d-store/user/user.effect';
import { userReducer } from '@d-store/user/user.reducer';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppConfigReducer } from '@d-store/app-config/app-config.reducer';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

export const imports = [
  CommonModule,
  BrowserModule,
  HttpClientModule,
  AppRoutingModule,
  BrowserAnimationsModule,

  //#region OAuth
  OAuthModule.forRoot(),
  //#endregion

  //#region components
  LayoutModule,
  BaseToastComponent,
  BaseSpinnerComponent,
  //#endregion

  //#region Redux
  StoreModule.forRoot({
    // auth: authReducer,
    currentUser: userReducer,
    appConfig: AppConfigReducer,
  }),
  // EffectsModule.forRoot([AuthEffects, UserEffects]),
  //#endregion

  //#region Redux
  TranslateModule.forRoot({
    defaultLanguage: 'en',
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient],
    },
  }),
  //#endregion
];
